import articleImage1 from '../../assets/images/Article/Article 1.svg';
import articleImage2 from '../../assets/images/Article/Article 2.svg';
import articleImage3 from '../../assets/images/Article/Article 3.svg';
import articleImage4 from '../../assets/images/Article/Article 4.svg';
import articleImage5 from '../../assets/images/Article/Article 5.svg';
import articleImage6 from '../../assets/images/Article/Article 6.svg';
import blogImage1 from '../../assets/images/Blog/Articles 1.svg';
import blogImage2 from '../../assets/images/Blog/Articles 2.svg';
import blogImage3 from '../../assets/images/Blog/Articles 3.svg';
import blogImage4 from '../../assets/images/Blog/Articles 4.svg';
import blogImage5 from '../../assets/images/Blog/Articles 5.svg';
import blogImage6 from '../../assets/images/Blog/Articles 6.svg';
import blogImage7 from '../../assets/images/Blog/Articles 7.svg';
import blogImage8 from '../../assets/images/Blog/Articles 8.svg';
import blogImage9 from '../../assets/images/Blog/Articles 9.svg';
import blogImage10 from '../../assets/images/Blog/Articles 10.svg';
import blogImage11 from '../../assets/images/Blog/Articles 11.svg';
import blogImage12 from '../../assets/images/Blog/Articles 12.svg';
import cartPopup from '../../assets/images/E-Commerce/Cart Popup.svg';
import cart from '../../assets/images/E-Commerce/Cart.svg';
import checkout from '../../assets/images/E-Commerce/Checkout.svg';
import complete from '../../assets/images/E-Commerce/Complete.svg';
import delivery from '../../assets/images/E-Commerce/Delivery.svg';
import ecomItem2 from '../../assets/images/E-Commerce/Item 2.svg';
import ecomItem from '../../assets/images/E-Commerce/Item.svg';
import paypal from '../../assets/images/E-Commerce/Paypal.svg';
import products1 from '../../assets/images/E-Commerce/Products 1.svg';
import products2 from '../../assets/images/E-Commerce/Products 2.svg';
import products3 from '../../assets/images/E-Commerce/Products 3.svg';
import rate from '../../assets/images/E-Commerce/Rate.svg';
import feature1 from '../../assets/images/Features/Features 1.svg';
import feature2 from '../../assets/images/Features/Features 2.svg';
import feature3 from '../../assets/images/Features/Features 3.svg';
import feature4 from '../../assets/images/Features/Features 4.svg';
import feature5 from '../../assets/images/Features/Features 5.svg';
import feature6 from '../../assets/images/Features/Features 6.svg';
import gallery1 from '../../assets/images/Gallery/Gallery 1.svg';
import gallery2 from '../../assets/images/Gallery/Gallery 2.svg';
import gallery3 from '../../assets/images/Gallery/Gallery 3.svg';
import gallery4 from '../../assets/images/Gallery/Gallery 4.svg';
import gallery5 from '../../assets/images/Gallery/Gallery 5.svg';
import gallery6 from '../../assets/images/Gallery/Gallery 6.svg';
import header1 from '../../assets/images/Header/Header 1.svg';
import header2 from '../../assets/images/Header/Header 2.svg';
import header3 from '../../assets/images/Header/Header 3.svg';
import header4 from '../../assets/images/Header/Header 4.svg';
import header5 from '../../assets/images/Header/Header 5.svg';
import header6 from '../../assets/images/Header/Header 6.svg';
import error404 from '../../assets/images/Misc/404.svg';
import about from '../../assets/images/Misc/About.svg';
import analitycs from '../../assets/images/Misc/Analitycs.svg';
import calender from '../../assets/images/Misc/Calender.svg';
import cards from '../../assets/images/Misc/Cards.svg';
import contact from '../../assets/images/Misc/Contact.svg';
import counter from '../../assets/images/Misc/Counter.svg';
import error from '../../assets/images/Misc/Error.svg';
import faqs from '../../assets/images/Misc/Faqs.svg';
import forum from '../../assets/images/Misc/Forum.svg';
import loading from '../../assets/images/Misc/Loading.svg';
import price1 from '../../assets/images/Misc/Price 1.svg';
import price2 from '../../assets/images/Misc/Price 2.svg';
import progress from '../../assets/images/Misc/Progress.svg';
import searchresults from '../../assets/images/Misc/Search results.svg';
import search from '../../assets/images/Misc/Search.svg';
import settings from '../../assets/images/Misc/Settings.svg';
import sitemap from '../../assets/images/Misc/Sitemap.svg';
import socials from '../../assets/images/Misc/Socials.svg';
import steps from '../../assets/images/Misc/Steps.svg';
import subscribde from '../../assets/images/Misc/Subscribde.svg';
import tags from '../../assets/images/Misc/Tags.svg';
import team from '../../assets/images/Misc/Team.svg';
import underContruction from '../../assets/images/Misc/Under Contruction.svg';
import files from '../../assets/images/Multimedia/Files.svg';
import songs1 from '../../assets/images/Multimedia/Songs 1.svg';
import songs2 from '../../assets/images/Multimedia/Songs 2.svg';
import songs3 from '../../assets/images/Multimedia/Songs 3.svg';
import uploadFiles from '../../assets/images/Multimedia/Upload Files.svg';
import uploadImage from '../../assets/images/Multimedia/Upload Image.svg';
import videoPlayer1 from '../../assets/images/Multimedia/Video Player 1.svg';
import videoPlayer2 from '../../assets/images/Multimedia/Video Player 2.svg';
import videos1 from '../../assets/images/Multimedia/Videos 1.svg';
import videos2 from '../../assets/images/Multimedia/Videos 2.svg';
import videos3 from '../../assets/images/Multimedia/Videos 3.svg';
import videos4 from '../../assets/images/Multimedia/Videos 4.svg';
import forgotPassword1 from '../../assets/images/Sign in/Forgot Password 1.svg';
import forgotPassword2 from '../../assets/images/Sign in/Forgot Password 2.svg';
import signin1 from '../../assets/images/Sign in/Sign in 1.svg';
import signin2 from '../../assets/images/Sign in/Sign in 2.svg';
import signUp1 from '../../assets/images/Sign in/Sign Up 1.svg';
import signUp2 from '../../assets/images/Sign in/Sign Up 2.svg';
import chat from '../../assets/images/Socials/Chat.svg';
import comments from '../../assets/images/Socials/Comments.svg';
import connection from '../../assets/images/Socials/Connection.svg';
import feeds from '../../assets/images/Socials/Feeds.svg';
import profile1 from '../../assets/images/Socials/Profile 1.svg';
import profile2 from '../../assets/images/Socials/Profile 2.svg';
import profile3 from '../../assets/images/Socials/Profile 3.svg';
import profile4 from '../../assets/images/Socials/Profile 4.svg';
import userSettings2 from '../../assets/images/Socials/User Settings 2.svg';
import userSettings from '../../assets/images/Socials/User Settings.svg';
import users2 from '../../assets/images/Socials/Users 2.svg';
import users from '../../assets/images/Socials/Users.svg';

export default [
  {
    label: 'Article',
    img: articleImage1,
  },
  {
    label: 'Article',
    img: articleImage2,
  },
  {
    label: 'Article',
    img: articleImage3,
  },
  {
    label: 'Article',
    img: articleImage4,
  },
  {
    label: 'Article',
    img: articleImage5,
  },
  {
    label: 'Article',
    img: articleImage6,
  },
  {
    label: 'Blog',
    img: blogImage1,
  },
  {
    label: 'Blog',
    img: blogImage2,
  },
  {
    label: 'Blog',
    img: blogImage3,
  },
  {
    label: 'Blog',
    img: blogImage4,
  },
  {
    label: 'Blog',
    img: blogImage5,
  },
  {
    label: 'Blog',
    img: blogImage6,
  },
  {
    label: 'Blog',
    img: blogImage7,
  },
  {
    label: 'Blog',
    img: blogImage8,
  },
  {
    label: 'Blog video',
    img: blogImage9,
  },
  {
    label: 'Blog video',
    img: blogImage10,
  },
  {
    label: 'Blog',
    img: blogImage11,
  },
  {
    label: 'Blog video',
    img: blogImage12,
  },
  {
    label: 'Cart pop up',
    img: cartPopup,
  },
  {
    label: 'Cart',
    img: cart,
  },
  {
    label: 'Checkout',
    img: checkout,
  },
  {
    label: 'Checkout Complete',
    img: complete,
  },
  {
    label: 'Checkout Delivery',
    img: delivery,
  },
  {
    label: 'Product Item',
    img: ecomItem2,
  },
  {
    label: 'Product Item',
    img: ecomItem,
  },
  {
    label: 'Paypal',
    img: paypal,
  },
  {
    label: 'Product Item',
    img: products1,
  },
  {
    label: 'Product Item',
    img: products2,
  },
  {
    label: 'Product Item',
    img: products3,
  },
  {
    label: 'Rate',
    img: rate,
  },
  {
    label: 'Feature',
    img: feature1,
  },
  {
    label: 'Feature',
    img: feature2,
  },
  {
    label: 'Feature',
    img: feature3,
  },
  {
    label: 'Feature',
    img: feature4,
  },
  {
    label: 'Feature',
    img: feature5,
  },
  {
    label: 'Feature',
    img: feature6,
  },
  {
    label: 'Gallery Image',
    img: gallery1,
  },
  {
    label: 'Gallery Image',
    img: gallery2,
  },
  {
    label: 'Gallery Image',
    img: gallery3,
  },
  {
    label: 'Gallery Image',
    img: gallery4,
  },
  {
    label: 'Gallery Image',
    img: gallery5,
  },
  {
    label: 'Gallery Image',
    img: gallery6,
  },
  {
    label: 'Header Image',
    img: header1,
  },
  {
    label: 'Header Image',
    img: header2,
  },
  {
    label: 'Header Video',
    img: header3,
  },
  {
    label: 'Header Video',
    img: header4,
  },
  {
    label: 'Header Image',
    img: header5,
  },
  {
    label: 'Header Image',
    img: header6,
  },
  {
    label: 'Not Found 404',
    img: error404,
  },
  {
    label: 'About',
    img: about,
  },
  {
    label: 'Analitycs Chart',
    img: analitycs,
  },
  {
    label: 'Calender Schedule',
    img: calender,
  },
  {
    label: 'Cards',
    img: cards,
  },
  {
    label: 'Contact',
    img: contact,
  },
  {
    label: 'Counter Timer',
    img: counter,
  },
  {
    label: 'Error Fail',
    img: error,
  },
  {
    label: 'FAQS',
    img: faqs,
  },
  {
    label: 'Forum',
    img: forum,
  },
  {
    label: 'Loading Progress',
    img: loading,
  },
  {
    label: 'Price',
    img: price1,
  },
  {
    label: 'Price',
    img: price2,
  },
  {
    label: 'Loading Progress',
    img: progress,
  },
  {
    label: 'Search Results',
    img: searchresults,
  },
  {
    label: 'Search',
    img: search,
  },
  {
    label: 'Settings',
    img: settings,
  },
  {
    label: 'Sitemap',
    img: sitemap,
  },
  {
    label: 'Socials',
    img: socials,
  },
  {
    label: 'Steps',
    img: steps,
  },
  {
    label: 'Subscribe',
    img: subscribde,
  },
  {
    label: 'Tags',
    img: tags,
  },
  {
    label: 'Team',
    img: team,
  },
  {
    label: 'Under Contruction',
    img: underContruction,
  },
  {
    label: 'Files',
    img: files,
  },
  {
    label: 'Media Songs',
    img: songs1,
  },
  {
    label: 'Media Songs',
    img: songs2,
  },
  {
    label: 'Media Songs',
    img: songs3,
  },
  {
    label: 'Upload Files',
    img: uploadFiles,
  },
  {
    label: 'Upload Image',
    img: uploadImage,
  },
  {
    label: 'Video Player',
    img: videoPlayer1,
  },
  {
    label: 'Video Player',
    img: videoPlayer2,
  },
  {
    label: 'Video',
    img: videos1,
  },
  {
    label: 'Video',
    img: videos2,
  },
  {
    label: 'Video',
    img: videos3,
  },
  {
    label: 'Video',
    img: videos4,
  },
  {
    label: 'Forgot Password',
    img: forgotPassword1,
  },
  {
    label: 'Forgot Password',
    img: forgotPassword2,
  },
  {
    label: 'Sign In',
    img: signin1,
  },
  {
    label: 'Sign In',
    img: signin2,
  },
  {
    label: 'Sign Up',
    img: signUp1,
  },
  {
    label: 'Sign Up',
    img: signUp2,
  },
  {
    label: 'Chat',
    img: chat,
  },
  {
    label: 'Comments',
    img: comments,
  },
  {
    label: 'Connection',
    img: connection,
  },
  {
    label: 'Feeds',
    img: feeds,
  },
  {
    label: 'Profile',
    img: profile1,
  },
  {
    label: 'Profile',
    img: profile2,
  },
  {
    label: 'Profile',
    img: profile3,
  },
  {
    label: 'Profile',
    img: profile4,
  },
  {
    label: 'User Settings',
    img: userSettings2,
  },
  {
    label: 'User Settings',
    img: userSettings,
  },
  {
    label: 'User',
    img: users2,
  },
  {
    label: 'User',
    img: users,
  },
];
